import { Component, computed, input } from '@angular/core';
import { UIIconComponent, UiNumberComponent } from '@design-system';
import { SymbolDetailType } from '../../symbol-detail.component';

@Component({
	selector: 'app-symbol-detail-header',
	templateUrl: './symbol-detail-header.component.html',
	imports: [UiNumberComponent, UIIconComponent],
	host: {
		class: 'block w-full shrink-0'
	}
})
export class SymbolDetailHeaderComponent {
	readonly symbol = input.required<SymbolDetailType>();
	readonly collapsed = input(false);

	/** Up and down are both false for an unchanged price, which the template paints neutral. */
	readonly lastPriceUp = computed(() => this.symbol().lastPriceChangePercent > 0);
	readonly lastPriceDown = computed(() => this.symbol().lastPriceChangePercent < 0);
	readonly closingPriceUp = computed(() => this.symbol().closingPriceChangePercent > 0);
	readonly closingPriceDown = computed(() => this.symbol().closingPriceChangePercent < 0);
}
